var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[_c('div',{staticClass:"price-echart-header"},[_vm._v("价格指数")]),_c('p',{staticClass:"price-echart-header-type"}),_c('div',{ref:"myChart",style:({width: '800px', height: '350px'}),attrs:{"id":"myChart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }